// src/lib/slug.ts — slugify cu transliterare RO, PUR, partajat server↔client.
// Mutat din io_import.ts (F9-T5): clientul derivă slug-ul stratului nou de colectare din
// numele tastat, cu ACEEAȘI regulă ca importul — un „Stâlpi iluminat" dă același slug pe
// ambele căi, fără drift.

/**
 * Forma brută, FĂRĂ fallback: "" pentru intrări degenerate (doar punctuație/simboluri).
 * Pentru CHEI de atribut (F9-T5) — fallback-ul "layer" ar boteza tăcut o coloană „layer".
 */
export function slug_key(s: string): string {
	return s
		.replace(/[ăĂ]/g, "a")
		.replace(/[âÂ]/g, "a")
		.replace(/[îÎ]/g, "i")
		.replace(/[șşȘŞ]/g, "s")
		.replace(/[țţȚŢ]/g, "t")
		.toLowerCase()
		.replace(/[\s—-]+/g, "_") // spaces and em-dash → _
		.replace(/[^a-z0-9_-]/g, "")
		.replace(/_+/g, "_")
		.replace(/^_+|_+$/g, "")
}

/**
 * Numele AFIȘAT al unui strat importat: fără prefixul de plan al proiectantului. Fișierele Ordin 904
 * vin cu „BZ_COLTI_46439_PUG_20260820 — CaiComunicatie" sau „2_ZFPropusa"/„001_ZFPropusa"/„0_Limita UTR"
 * — în panoul de straturi ar apărea prefixul pe fiecare rând. Slug-ul rămâne derivat din numele
 * BRUT (stabilitatea re-importului); doar `config.name` e curățat. Fără prefix → neschimbat.
 */
export function clean_layer_name(src: string): string {
	const s = src.trim()
	// DOAR prefixul de plan al formatului 904: cod județ + localitate + SIRUTA + PUG + dată (+ sufix),
	// urmat de „ — ". Nu atingem liniuțele din numele libere („Conductă alimentare apă - Existent").
	const plan = s.match(/^[A-Z]{2}_[A-Za-z0-9_]*\d{3,}[A-Za-z0-9_]*\s+[—–]\s+(.+)$/)
	const cleaned = plan ? plan[1] : s.replace(/^\d{1,3}_\s*(?=\S)/, "")
	return cleaned.trim() || s
}

export function slugify(s: string): string {
	return slug_key(s) || "layer"
}

/**
 * Slug-uri de strat REZERVATE: segmente STATICE de rută care câștigă în fața
 * `/api/maps/:map/layers/:slug/...` — straturile „virtuale" din rapoarte.ts (`acte_geojson`,
 * `solicitari_geojson`) și zonificare.ts (`zonificare_actuala`, decizia 1.2). ⚠️ La orice strat
 * virtual NOU, intră și aici — altfel un strat real cu acel slug devine INACCESIBIL pe ruta de
 * geojson (comentariul-oglindă e la definițiile rutelor din rapoarte.ts / layers.ts / public.ts).
 */
export const VIRTUAL_LAYER_SLUGS: readonly string[] = ["acte", "solicitari", "zonificare_actuala"]
